import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import CLoseImg from "../../../assets/images/closeIconModal.svg";
import bykea from "../../../assets/images/riderprof.png";

interface FindModalProps {
    show: boolean;
    onCloseClick: () => void;
    activities: any
}

const TrackOrderMOdal: React.FC<FindModalProps> = ({ show, onCloseClick, activities }) => {
    return (
        <Modal isOpen={show} centered className="trackMOdal">
            <img
                data-testing-id="closeIcon"
                onClick={onCloseClick}
                className='closeIconModal'
                src={CLoseImg}
                alt=""
            />
            <ModalBody className="modal_Body">
                <div className="mainDv">
                    <div className="headerDV">
                        <div className="headnigRow">
                            <h5>Tracking ID: <span className="text-dark">#102574389573434</span></h5>
                            <i className='bx bx-copy text-secondary fw-bold ms-1 fs-5 cursor-pointer'></i>
                        </div>
                        <div className="byKaDV">
                            <img src={bykea} alt="Bykea" />
                            <div className="content">
                                <h5>Logistic Partner</h5>
                                <h6>Bykea</h6>
                            </div>
                        </div>
                        <h4>Status</h4>
                    </div>
                    <div className="border"></div>
                    <div className="bodyDV">
                        {activities?.orders?.map((activity: any, index: number) => (
                            <div className="bodyItemDV">
                                <div className="dataDv">
                                    <h4 className="mb-1">
                                        {new Date(activity?.createdOn).toLocaleDateString("en-US", { month: "short", day: "2-digit" }).replace(" ", ".")}
                                    </h4>
                                    <p>{new Date(activity?.createdOn).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })}</p>
                                </div>
                                <div className="proBar">
                                    <div className={`dot ${index === 0 ? "blue-bg" : ""}`}></div>
                                    {index !== activities.orders.length - 1 && (
                                        <div className={`bar ${index === 0 ? "blue-bg" : ""}`}></div>
                                    )}
                                </div>

                                <div className="orderDv">
                                    <h4 className="mb-1">{activity?.sellerTitle}</h4>
                                    <h6>{activity?.sellerDescription}</h6>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

TrackOrderMOdal.propTypes = {
    show: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    activities: PropTypes.any
};

export default TrackOrderMOdal;
